<template>
  <router-btn :text="$t('servicesystem.common_objects.commonterms.service_report')" :icon="'mdi-receipt-text'"
    :color="'secondary'" :disabled="false" outlined :textbtn="textbtn" :large="large" :small="small" @Press="open()">
  </router-btn>
</template>


<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "ServiceReportBtn",
  props: ["large", "small", "textbtn"],
  components: {
    RouterBtn,
  },

  data() {
    return {};
  },

  methods: {

    open() {
      this.$router.push({ name: 'GenerateServiceReport', params: { templateKey: 'default' } });
    },
  },
};
</script>
